import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.error.cause.js";
import { defineComponent, ref, reactive, onMounted, toRefs } from 'vue';
import apis from "@/api";
import UsersOfRole from "./UsersOfRole";
export default defineComponent({
  components: {
    UsersOfRole
  },
  setup(props, ctx) {
    const roleForm = ref(null);
    const userRef = ref(null);
    const data = reactive({
      roleId: '',
      isEdit: false,
      loading: false,
      queryParam: {},
      paginationObj: {},
      tableData: [],
      newRole: {},
      userShow: false,
      addDialogShow: false,
      rules: {
        roleId: [{
          validator: validateRoleId,
          trigger: 'blur'
        }],
        roleName: [{
          required: true,
          message: '请输入角色名称',
          trigger: 'blur'
        }]
      }
    });
    function validateRoleId(rule, value, callback) {
      if (!data.isEdit && value) {
        apis.checkRoleCode({
          roleId: value
        }).then(res => {
          if (res.success) {
            if (res.data) {
              callback(new Error('角色编码已存在'));
            } else {
              callback();
            }
          } else {
            callback(new Error(res.msg));
          }
        });
      } else {
        callback();
      }
    }
    const submit = () => {
      roleForm.value.validate(valid => {
        if (valid) {
          if (data.isEdit) {
            apis.editRole(data.newRole).then(res => {
              if (res.success) {
                loadRolePage();
                ElMessage.success('角色修改成功');
              } else {
                ElMessage.error(res.msg);
              }
              data.addDialogShow = false;
            });
          } else {
            apis.addRole(data.newRole).then(res => {
              if (res.success) {
                loadRolePage();
                ElMessage.success('角色新增成功');
              } else {
                ElMessage.error(res.msg);
              }
              data.addDialogShow = false;
            });
          }
        }
      });
    };
    const loadRolePage = () => {
      data.loading = true;
      apis.rolePage({
        ...data.queryParam,
        ...data.paginationObj
      }).then(res => {
        if (res.success) {
          var _res$data;
          const {
            records,
            size,
            total,
            current
          } = (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : {};
          data.tableData = records !== null && records !== void 0 ? records : [];
          data.paginationObj = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {
        data.loading = false;
      });
    };
    const handleSizeChange = val => {
      data.paginationObj.pageSize = val;
      loadRolePage();
    };
    const handleCurrentChange = val => {
      data.paginationObj.pageNo = val;
      loadRolePage();
    };
    const showRefUsers = row => {
      data.roleId = row.roleId;
      data.userShow = true;
      userRef.value.initDialog();
    };
    const showDialog = row => {
      if (row && row.id) {
        // 编辑
        data.isEdit = true;
        data.newRole = row;
      } else {
        // 新增
        data.isEdit = false;
        data.newRole = {};
      }
      data.addDialogShow = true;
    };
    const handleState = (row, state) => {
      row.state = state;
      apis.editRole(row).then(res => {
        if (res.success) {
          loadRolePage();
          ElMessage.success('角色修改成功');
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    onMounted(() => {
      loadRolePage();
    });
    return {
      ...toRefs(data),
      roleForm,
      userRef,
      submit,
      loadRolePage,
      handleSizeChange,
      handleCurrentChange,
      showRefUsers,
      showDialog,
      handleState
    };
  }
});